export class MembershipProgramFeeStructure {
    public static ABSORBED = 'ABSORBED';
    public static NO_ORG = 'NO_ORG';
    public static DUAL = 'DUAL';
}
